import { ActionTypes } from "@/App/constants/actionTypes";
import { PharmacyTypes, GeneralTypes } from "@/types";

type SearchForPharmacyAction = {
  type: typeof ActionTypes.SEARCH_FOR_PHARMACY_LIST;
  payload: GeneralTypes.QueryOptions;
  formName: string;
};

export const searchForPharmacy = (data: { data: GeneralTypes.QueryOptions; formName: string }): SearchForPharmacyAction => {
  return {
    type: ActionTypes.SEARCH_FOR_PHARMACY_LIST,
    payload: data.data,
    formName: data.formName,
  };
};

type SearchForPharmacyResultsAction = {
  type: typeof ActionTypes.SEARCH_FOR_PHARMACY_LIST_RESULTS;
  payload: PharmacyTypes.PharmacySearchResponse;
};

export const searchForPharmacyResults = (data: PharmacyTypes.PharmacySearchResponse): SearchForPharmacyResultsAction => {
  return {
    type: ActionTypes.SEARCH_FOR_PHARMACY_LIST_RESULTS,
    payload: data,
  };
};

export type PharmacySearchActions = SearchForPharmacyAction | SearchForPharmacyResultsAction;
